import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-payments',
  templateUrl: './icon-payments.component.html',
  styleUrls: ['./icon-payments.component.scss']
})
export class IconPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
